class CollectingInstitutionService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/collectingInstitution/collecting-institutions';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ collectingInstitution }) {
    const { data } = await this.axios.post(this.url, collectingInstitution);
    return data;
  }

  async update({ collectingInstitution }) {
    const { data } = await this.axios.put(this.url, collectingInstitution);
    return data;
  }

  async archive({ collectingInstitution }) {
    const { _id: id } = collectingInstitution;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: collectingInstitution });
    return data;
  }
}

export default CollectingInstitutionService;
